export default __webpack_public_path__ + "static/media/dental-chavez.6f522600.png";